import { computed, reactive, type Ref } from 'vue'
import type { EmojiCategory, EmojiConfig, EmojiSubcategory } from '../../../shared/model/emoji-config'

export function useSearch(emojiConfig: Ref<EmojiConfig>, searchString: Ref<string>) {
  const filterSubcategory = (subcategory: EmojiSubcategory, searchStringValue: string) => {
    if (subcategory.name.toLowerCase().includes(searchStringValue)) {
      return subcategory
    }

    const filteredSubcategory: EmojiSubcategory = {
      ...subcategory,
      content: [],
    }

    for (const emoji of subcategory.content) {
      if (emoji.name.toLowerCase().includes(searchStringValue)) {
        filteredSubcategory.content.push(emoji)
      }
    }

    if (filteredSubcategory.content.length === 0) return null
    return filteredSubcategory
  }

  const filterCategory = (category: EmojiCategory, searchStringValue: string) => {
    const filteredCategory: EmojiCategory = {
      ...category,
      content: [],
    }

    for (const subcategory of category.content) {
      const filteredSubcategory = filterSubcategory(subcategory, searchStringValue)
      if (filteredSubcategory === null) continue
      filteredCategory.content.push(filteredSubcategory)
    }

    if (filteredCategory.content.length === 0) return null
    return filteredCategory
  }

  const filteredEmojiConfig = computed(() => {
    const searchStringValue = searchString.value.toLowerCase()
    const newEmojiConfig: EmojiConfig = []

    for (const category of emojiConfig.value) {
      const filteredCategory = filterCategory(category, searchStringValue)
      if (filteredCategory === null) continue
      newEmojiConfig.push(filteredCategory)
    }

    return reactive(newEmojiConfig)
  })

  return filteredEmojiConfig
}
